var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input } from '@angular/core';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
var TableGeneralSettingComponent = /** @class */ (function (_super) {
    __extends(TableGeneralSettingComponent, _super);
    function TableGeneralSettingComponent(injector) {
        return _super.call(this, injector) || this;
    }
    Object.defineProperty(TableGeneralSettingComponent.prototype, "stroke", {
        get: function () {
            return this._stroke;
        },
        set: function (v) {
            this.data.stroke = v;
            this._stroke = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableGeneralSettingComponent.prototype, "splitLine", {
        get: function () {
            return this._splitLine;
        },
        set: function (v) {
            this.data.splitLine = v;
            this._splitLine = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableGeneralSettingComponent.prototype, "fill", {
        get: function () {
            return this._fill;
        },
        set: function (v) {
            this.data.fill = v;
            this._fill = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableGeneralSettingComponent.prototype, "isHiddenColumnSplitLine", {
        get: function () {
            return this._isHiddenColumnSplitLine;
        },
        set: function (v) {
            this._isHiddenColumnSplitLine = v;
            this.data.isHiddenColumnSplitLine = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableGeneralSettingComponent.prototype, "isHiddenRowSplitLine", {
        get: function () {
            return this._isHiddenRowSplitLine;
        },
        set: function (v) {
            this._isHiddenRowSplitLine = v;
            this.data.isHiddenRowSplitLine = v;
        },
        enumerable: true,
        configurable: true
    });
    TableGeneralSettingComponent.prototype.ngOnInit = function () {
        this.initData();
    };
    TableGeneralSettingComponent.prototype.initData = function () {
        this._stroke = this.data.stroke;
        this._splitLine = this.data.splitLine;
        this._fill = this.data.fill;
        this._isHiddenColumnSplitLine = this.data.isHiddenColumnSplitLine;
        this._isHiddenRowSplitLine = this.data.isHiddenRowSplitLine;
    };
    TableGeneralSettingComponent.prototype.setStrokeColor = function (color) {
        this.stroke = color;
    };
    TableGeneralSettingComponent.prototype.setFillColor = function (color) {
        this.fill = color;
    };
    TableGeneralSettingComponent.prototype.setSplitLineColor = function (color) {
        this.splitLine = color;
    };
    __decorate([
        Input()
    ], TableGeneralSettingComponent.prototype, "data", void 0);
    TableGeneralSettingComponent = __decorate([
        Component({
            selector: 'table-general-setting',
            styles: [".polygon-general{ .form-inline-label{ float: left; margin-top:3px; } } .color-picker{ width: 100px; } .design-color-picker{ position: relative; } .design-color-picker-float{ float: left; z-index: 999; }"],
            template: "<div [busyIf]=\"isLoading\" class=\"polygon-general\"> <div class=\"fe-modal-content\"> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-half-line float-left\"> <div class=\"fe-transverse-title\">{{lc(\"StraightLineColor\")}}:</div> <div class=\"fe-transverse-component color-picker design-color-picker design-color-picker-float\"> <color-picker [color]=\"stroke\" (sentColor)=\"setStrokeColor($event)\"></color-picker> </div> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"SharpFill\")}}:</label> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"fill\" (sentColor)=\"setFillColor($event)\"></color-picker> </div> </div> </div> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-half-line float-left\"> <div class=\"fe-transverse-title\">{{lc(\"SplitLineColor\")}}:</div> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"splitLine\" (sentColor)=\"setSplitLineColor($event)\"></color-picker> </div> </div> </div> <div  class=\"fe-option-head\"> <label for=\"hiddenColumnSplitLine\"> <input id=\"hiddenColumnSplitLine\" type=\"checkbox\" [(ngModel)]=\"isHiddenColumnSplitLine\"> <span>{{lc(\"HiddenColumnSegmentationLine\")}}</span> </label> </div> <div  class=\"fe-option-head\"> <label for=\"hiddenRowSplitLine\"> <input id=\"hiddenRowSplitLine\" type=\"checkbox\" [(ngModel)]=\"isHiddenRowSplitLine\"> <span>{{lc(\"HiddenRowSegmentationLine\")}}</span> </label> </div> </div> </div>"
        })
    ], TableGeneralSettingComponent);
    return TableGeneralSettingComponent;
}(ConfigureComponentBase));
export { TableGeneralSettingComponent };
